/* Splide slider styles */
.splide {
  padding: 1rem;
  position: relative;
  margin: 0 auto;
}

/* Hide screen reader element without affecting layout */
.splide__sr {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Splide handles slide and list widths via inline styles based on the
   `perPage`/`gap`/`padding` options. The official splide.min.css (loaded
   dynamically by loadSplide) provides the supporting layout rules. We must
   NOT override .splide__list width or .splide__slide width here — doing so
   creates a circular sizing fight that broke mixed shorts+regular galleries
   (slides ended up at ~50% of an inflated max-content list, overflowing the
   track and clipping the second slide). */

.slider-video-item {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f4f6f8;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.slider-video-item:hover {
  transform: scale(1.02);
}

.loading-slider {
  text-align: center;
  padding: 2rem;
  font-size: 1.1rem;
  color: #666;
}

/* Splide navigation arrows */
.splide__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3rem;
  height: 3rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  border: none;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.splide__arrow--prev {
  left: -1.5rem;
}

.splide__arrow--prev svg {
  transform: scaleX(-1); /* Flip the arrow horizontally */
}

.splide__arrow--next {
  right: -1.5rem;
}

/* Sliders whose edges sit within the arrow overhang of the viewport edge
   (e.g. a theme section spanning the full page width) get this class from the
   component — overhanging arrows there would poke outside the viewport and
   create horizontal overflow, so they move inside the track instead. */
video-gallery.videoreel-inset-arrows .splide__arrow--prev {
  left: 1.2rem;
}

video-gallery.videoreel-inset-arrows .splide__arrow--next {
  right: 1.2rem;
}

.splide__arrow:hover {
  background: #fff;
}

.splide__arrow svg {
  width: 1.2rem;
  height: 1.2rem;
  fill: #333;
}

/* Hide pagination */
.splide__pagination {
  display: none;
} 